import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#5C728A",
      d: "M22 12a9.998 9.998 0 0 1-12.96 9.552c.408-.665 1.017-1.754 1.242-2.62.121-.468.621-2.38.621-2.38.327.621 1.278 1.15 2.29 1.15 3.017 0 5.19-2.775 5.19-6.222 0-3.303-2.697-5.774-6.165-5.774-4.315 0-6.61 2.895-6.61 6.052 0 1.468.783 3.294 2.03 3.875.189.089.29.049.334-.133.032-.137.201-.819.278-1.133a.3.3 0 0 0-.069-.286c-.407-.504-.737-1.424-.737-2.283 0-2.205 1.669-4.338 4.516-4.338 2.455 0 4.177 1.673 4.177 4.068 0 2.706-1.367 4.58-3.145 4.58-.98 0-1.718-.81-1.48-1.806.282-1.19.827-2.471.827-3.33 0-.766-.412-1.407-1.266-1.407-1.005 0-1.81 1.036-1.81 2.427 0 .887.297 1.484.297 1.484s-.987 4.185-1.169 4.967c-.201.863-.12 2.081-.036 2.871A10 10 0 0 1 2 12C2 6.476 6.476 2 12 2s10 4.476 10 10"
    }, null, -1)
  ]))]))
}
export default { render: render }